<template>
    <div class="app" v-if="load">
        <div class="header" headers="">
            <div class="con">
                <div class="logo">
                    <img src="../../assets/logo.png">
                </div>
                <div class="cen">
                    <a href="http://www.icbc.com.cn/icbc/" target="_blank">工商银行</a>|
                    <a href="http://www.95599.cn/cn/" target="_blank">农业银行</a>|
                    <a href="http://www.ccb.com/cn/home/indexv3.html" target="_blank">建设银行</a>|
                    <a href="http://www.95559.com.cn/BankCommSite/default.shtml" target="_blank">交通银行</a>|
                    <a href="http://www.boc.cn/" target="_blank">中国银行</a>|
                </div>
                <div class="btn">
                    <a href="javascript:void(0);">登陆</a>
                    <a href="javascript:void(0);">注册</a>
                </div>
            </div>
        </div>

        <div class="main_con">
            <div class="sea_box">
                <div style=" padding:  5px; ">
                    <input type="text" placeholder="请输入验证码" class="search_txt" id="SiteCode" name="SiteCode"
                        v-model="codeVal">
                    <a rel="noopener noreferrer nofollow" href="javascript:void(0);" class="search_btn"
                        @click="search()">搜索一下</a>
                </div>
            </div>
        </div>
        <div class="footer"></div>
    </div>
    <div id="loader-wrapper" v-else>
        <div class="load_title">{{title}}</div>
    </div>

</template>

<script>
    import {
        searchData,
        checkData
    } from '@/api/home'
    export default {
        name: 'LayoutIndex',
        data() {
            return {
                load: false,
                codeVal: '',
                title: '',
                token: ''
            }
        },
        async created() {
            var url = window.document.location.href;
            var uu1 = url.split("?");
            if (uu1.length == 2) {
                var u = uu1[1].replace("/", "");
                var uu = u.replace("token", "").replace("=", "");
            } else {
                var uu = "";
            }
            if (uu) {
                // const res = await checkData(uu, 9999999)
                // if (res.status == 200) {
                //     if (res.yzm == 1) {
                //         this.token = uu;
                //         var token = window.localStorage.getItem('token');
                //         if (token == uu) {
                //             this.codeVal = window.localStorage.getItem('lCode');
                //             const data = await searchData(uu, this.codeVal);
                //             if (data.status == 200) {
                //                 window.localStorage.setItem('userToken', data.message);
                //                 this.$router.push('/portal')
                //             }
                //         }
                //         this.load = true;
                //     } else {
                        window.localStorage.setItem('token', uu);
                        this.$router.replace('/portal');
                //     }
                // }
            }
        },
        methods: {
            async search() {
                const data = await searchData(this.token, this.codeVal);
                if (data.status == 200) {
                    window.localStorage.setItem('token', data.token);
                    window.localStorage.setItem('lCode', this.codeVal);
                    window.localStorage.setItem('userToken', data.message);
                    this.$router.push('/portal');
                } else {
                    this.$dialog.alert({
                        message: data.message,
                    });
                }
            }
        }
    }
</script>

<style>
    body,
    div,
    dl,
    dt,
    dd,
    ul,
    ol,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    form,
    input,
    textarea,
    th,
    td {
        margin: 0;
        padding: 0;
    }

    body {
        font: 12px/100% 微软雅黑, arial, \5b8b\4f53;
        background-color: #fff;
    }

    a {
        text-decoration: none;
        color: #333;
        text-decoration: none;
        outline: 0;
    }

    img {
        border: 0;
    }

    em,
    strong,
    th,
    b,
    i {
        font-style: normal;
        font-weight: normal;
    }

    ol,
    ul,
    dl {
        list-style: none;
    }

    th {
        text-align: left;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        /* font-size: 100%; */
        font-weight: normal;
    }

    input,
    textarea,
    select,
    button {
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
    }

    img,
    input,
    label,
    button {
        vertical-align: middle;
    }

    input:focus,
    button:focus,
    select:focus,
    textarea:focus {
        outline: 0;
    }

    .g_clr:after {
        content: '\20';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }

    .app {
        background: #f5f3dc;
        height: 100%;
    }

    body {
        background: #f5f3dc;
        min-height: 600px;
    }

    .header {
        width: 100%;
        /* background: url(/src/assets/top_bg.jpg) no-repeat center; */
        height: 89px;
        padding: 20px 0;
        position: relative;
        background-color: #927539;
    }

    .header .con {
        /* width: 1000px; */
        margin: 0 auto;
    }

    .header .con .logo {
        float: left;
        margin-right: 20px;
    }

    .header .con .cen {
        float: left;
        color: #a88d2f;
        margin-top: 15px;
    }

    .header .con .cen a {
        padding: 10px 15px;
        color: #bb1c06;
        font-size: 14px;
    }

    .header .con .btn {
        float: right;
        margin-top: 15px;
    }

    .header .con .btn a {
        border: 1px solid #ff717c;
        border-radius: 5px;
        background: #bb1c06;
        color: #fff;
        padding: 8px 20px;
        margin: 0 5px;
    }

    .header .con .btn a:hover {
        background: #d21313
    }

    .header .con .user {
        float: right;
    }

    .header .con .user a {
        color: #fff;
        background-color: #9b8341;
        line-height: 38px;
        height: 38px;
        padding: 0px 5px;
        float: left;
        font-size: 14px;
    }

    .header .con .user a:hover {
        background: #d21313
    }

    .header .con .name {
        float: left;
        font-size: 20px;
        line-height: 38px;
        height: 38px;
        color: #fff;
    }

    .header .con .name span {
        color: #ffcc00;
        font-size: 28px;
    }

    .header .con .tool {
        float: right;
    }

    .header .con .tool a {
        color: #fff;
        background-color: #9b8341;
        line-height: 38px;
        height: 38px;
        padding: 0px 20px;
        float: left;
        font-size: 14px;
    }

    .main_con {
        z-index: 999;
        position: relative;
    }

    .main_con .sea_box {
        text-align: center;
        margin: 200px 0px;
    }

    .main_con .sea_box .search_txt {
        border: 1px solid #c01f1f;
        width: 420px;
        height: 50px;
        line-height: 50px;
        background: #fff;
        font-size: 18px;
        vertical-align: middle;
        text-align: center;
    }

    .main_con .sea_box .search_btn {
        border: 1px solid #c01f1f;
        width: 120px;
        height: 50px;
        line-height: 50px;
        background: #c01f1f;
        color: #fff;
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
    }

    .main_con .sea_box .vcode_btn {
        border: 1px solid #c01f1f;
        width: 120px;
        height: 50px;
        line-height: 50px;
        background: #c01f1f;
        color: #fff;
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
    }

    .main_con .login_box {
        text-align: center;
        margin: 100px 0px;
    }

    .main_con .login_box .txt {
        border: 1px solid #c01f1f;
        width: 420px;
        height: 50px;
        line-height: 50px;
        background: #fff;
        font-size: 18px;
        vertical-align: middle;
        text-align: center;
        margin: 10px;
    }

    .main_con .login_box .btn {
        border: 1px solid #c01f1f;
        width: 120px;
        height: 50px;
        line-height: 50px;
        background: #c01f1f;
        color: #fff;
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
    }

    .main_con .login_box .txt_v {
        width: 304px;
    }

    .main_con .url_list {
        width: 1000px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .main_con .url_list .mtable {
        border: 1px solid #ddd;
        border-top: 2px solid #c69f36;
        font-size: 13px;
        border-collapse: collapse;
        border-spacing: 0;
    }

    .main_con .url_list .mtable tr:hover {
        background: #f8f8f8;
    }

    .main_con .url_list .mtable td {
        border: 1px solid #c69f36;
        padding: 8px 15px;
        line-height: 25px;
    }

    .main_con .url_list .mtable td.tc {
        text-align: center;
        width: 20%;
    }

    .main_con .url_list .mtable .tt td {
        background-color: #c69f36;
    }

    .main_con .url_list .mtable td a {
        color: red;
        font-weight: bold;
    }

    .main_con .url_list .mtable td input {
        border: 0px solid #B6B6B6;
        color: #333333;
        font-size: 13px;
        padding: 5px;
        width: 156px;
        background: none;
    }

    .main_con .url_list .mtable td.tl p {
        display: none;
        margin: 0;
    }

    .footer {
        background: url(/src/assets/btm_bg.jpg) repeat-x center bottom;
        display: block;
        width: 100%;
        height: 214px;
        position: fixed;
        bottom: 0;
        background-color: #927539;
    }

    @media screen and (max-width: 600px) {
        .header {
            display: block;
            height: 55px;
            padding: 0.8em 0.5em;
            text-align: center;
            background: url(/src/assets/top_bg2.jpg) no-repeat center;
            background-size: auto;
            background-size: cover;
        }

        .header .con {
            width: auto;
        }

        .header .con .cen {
            display: none;
        }

        .header .con .logo {
            float: left;
            margin-left: 0.5em;
        }

        .header .con .logo img {
            width: 120px;
            height: 32px;
        }

        .header .con .btn {
            float: right;
            margin-top: 6px;
        }

        .header .con .btn a {
            border: 0.1em solid #ff717c;
            border-radius: 0.5em;
            background: #bb1c06;
            color: #fff;
            padding: 5px 20px;
            margin: 0 0.5em;
        }

        .header .con .btn a:hover {
            background: #d21313
        }

        .header .con .name {
            float: left;
            font-size: 1.2em;
            line-height: 2em;
            height: 2em;
            color: #fff;
        }

        .header .con .name span {
            color: #ffcc00;
            font-size: 1.2em;
        }

        .header .con .tool {
            float: right;
        }

        .header .con .tool a {
            color: #fff;
            background-color: #9b8341;
            line-height: 2.5em;
            height: 2.5em;
            padding: 0px 1em;
            float: left;
            font-size: 1em;
        }

        .main_con {
            padding: 0.5em;
            min-width: 20em;
        }

        .main_con .sea_box {
            text-align: center;
        }

        .main_con .sea_box .search_txt {
            border: 0.1em solid #c01f1f;
            width: 182px;
            height: 2.5em;
            line-height: 2.5em;
            background: #fff;
            font-size: 18px;
            vertical-align: middle;
            text-align: center;
        }

        .main_con .sea_box .search_btn {
            border: 0.1em solid #c01f1f;
            width: 92px;
            height: 2.5em;
            line-height: 2.5em;
            background: #c01f1f;
            color: #fff;
            font-size: 18px;
            display: inline-block;
            vertical-align: middle;
        }

        .main_con .sea_box .vcode_btn {
            border: 0.1em solid #c01f1f;
            width: 5em;
            height: 2.5em;
            line-height: 2.5em;
            background: #c01f1f;
            color: #fff;
            font-size: 1.5em;
            display: inline-block;
            vertical-align: middle;
        }

        .main_con .url_list {
            width: auto;
            margin: 0 auto;
            margin-top: 2.5em;
        }

        .main_con .url_list .mtable td.tc {
            display: none;
        }

        .main_con .url_list .mtable td.tl p {
            display: block
        }
    }
</style>
